import { lazy } from 'react';

export const publicRoutes = [
  {
    path: '/login',
    exact: true,
    element: lazy(() => import('./pages/login/Login'))
  },
  {
    path: '/forgot-password',
    exact: true,
    element: lazy(() => import('./pages/login/ForgotPass'))
  },
  {
    path: '/reset-password/:token',
    exact: true,
    element: lazy(() => import('./pages/login/ResetPass'))
  },
  {
    path: '/download/:year/:type',
    exact: true,
    element: lazy(() => import('./pages/download/Download'))
  },
];

export const protectedRoutes = [
  {
    path: '/',
    exact: true,
    element: lazy(() => import('./pages/uploadData/UploadData'))
  },
  {
    path: '/financed-emissions/:metric/:submetric',
    exact: true,
    element: lazy(() => import('./pages/portfolio/Portfolio'))
  },
  {
    path: '/financed-emissions/compare-years',
    exact: true,
    element: lazy(() => import('./pages/portfolio/Portfolio'))
  },
  {
    path: '/financed-emissions/:metric',
    exact: true,
    element: lazy(() => import('./pages/portfolio/Portfolio'))
  },
  {
    path: '/climaterisk',
    exact: true,
    element: lazy(() => import('./pages/climateRiskAssessment/ClimateRiskAssessment'))
  },
  {
    path: '/climaterisk/:breakdown',
    exact: true,
    element: lazy(() => import('./pages/climateRiskAssessment/ClimateRiskAssessment'))
  },
  {
    path: '/reports',
    exact: true,
    element: lazy(() => import('./pages/reports/Reports'))
  },
  {
    path: '/helpandsupport',
    exact: true,
    element: lazy(() => import('./pages/helpandsupport/HelpAndSupport'))
  },
  {
    path: '/account',
    exact: true,
    element: lazy(() => import('./pages/account/Account'))
  },
]